export const AUTH_ROUTES: string[] = ['/register', '/login'];

export const PUBLIC_ROUTES: string[] = [
  ...AUTH_ROUTES,
  '/terms-of-service',
  '/privacy-policy',
  '/alpha-pilot-user-agreement',
  '/community',
  '/admin-login',
];

export const isPublicRoute = (path: string) =>
  !!PUBLIC_ROUTES.find((part) => path.startsWith(part));

export const isAuthRoute = (path: string) =>
  !!AUTH_ROUTES.find((part) => path.startsWith(part));
